import featureToggles from 'shared/featureToggles'

const SuccessViewBR = () => (
    <div className="success-container success-container-br text-center">
        <h5>{featureToggles.brNeoPurchaseFlow ? <T>auth.sign.up.success.br</T> : <T>auth.sign.up.success</T>}</h5>
    </div>
)

export default SuccessViewBR
